import { LoaderIcon } from "lucide-react"
import React from "react"

import { cn } from "@/utils/styles"

type ElementProps = React.SVGAttributes<SVGSVGElement>

export const IconLoader = ({ className, ...props }: ElementProps) => {
  return (
    <LoaderIcon
      {...props}
      className={cn("h-4 w-4 animate-spin text-gray-08", className)}
    />
  )
}
